export default __webpack_public_path__ + "static/harmReduction-cbd39764b05c6f09f613b8152c130b29.jpg";